// extracted by mini-css-extract-plugin
export var layoutContainer = "_8b-0";
export var layoutContainerNoRounding = "_8b-6";
export var layoutContainerOpen = "_8b-5";
export var layoutContainerResizing = "_8b-1";
export var mainContent = "_8b-2";
export var resizeDivider = "_8b-3";
export var slidePanel = "_8b-4";